<script>
  import { copyToClipboard } from "../../../../SinglePublish/script"
  import PreviewContent from "../../../../../Templates/Documents/Shared/previewContent.svelte"
  import notify from "../../../../../../Script/notify"
  import { loadTooltip } from "../../../../../../Script/loadTooltip"
  import { afterUpdate } from "svelte"
  /**
   * @type {import("../../../Script/document".bulkDocument)}
   */
  export let json
  /**
   * @type {Boolean} whether to show the copy popover or not
   */
  let popover = false
  /**
   * @type {Boolean} whether to show the view info modal or not
   */
  let showInfoModal = false

  afterUpdate(() => {
    loadTooltip()
    window.addEventListener("resize", loadTooltip)
  })

  /**
   * Copies the document URL to the clipboard and displays a popover notification.
   * Uses a try-catch block to handle errors.
   */
  const copyURL = async () => {
    try {
      // Copy the document URL to the clipboard using the 'copyToClipboard' function
      await copyToClipboard(json.url)

      // Set 'popover' to true to show the popover notification
      popover = true

      // Automatically hide the popover after 2000 milliseconds (2 seconds)
      setTimeout(() => {
        popover = false
      }, 500)
    } catch (error) {
      const info = "PAGE: Bulk Report\nEVENT: While copying document URL"
      notify.danger(error, info)
    }
  }
</script>

{#if showInfoModal}
  <div class="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 z-50 overflow-y-auto bg-[#000000cc] backdrop-blur-md transition-opacity">
      <div class="flex justify-center p-6 text-center mobile:p-12">
        <div class="relative h-fit w-full min-w-[276px] max-w-[700px] origin-top transform overflow-hidden bg-white text-left transition-all dark:bg-bodyblack">
          <div class="w-full transform select-none break-all rounded-md bg-white text-left transition-all dark:bg-bodyblack md:m-0">
            <div class="flex w-full items-center justify-between bg-blue-500 p-6 text-white">
              <h1 class="select-none text-xl font-medium">Blockchain Verified - More Info</h1>
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <span
                on:click={() => {
                  showInfoModal = false
                }}
              >
                <i class="fa-solid fa-xmark fa-lg cursor-pointer" />
              </span>
            </div>
            <div class="wordBreak p-6 pb-3 pl-0">
              <PreviewContent json={JSON.parse(json.metadata)} />
            </div>
            <div class="flex flex-row-reverse border-t border-t-[#e9ecef] bg-white p-6 dark:border-darkgray dark:bg-bodyblack">
              <button
                on:click={() => {
                  showInfoModal = false
                }}
                type="button"
                class="inline-flex justify-center rounded-full border border-transparent bg-blue-500 px-3 py-1.5 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring active:bg-blue-500 sm:ml-3 sm:text-sm"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
{/if}

<div class="mt-3 flex w-full items-center justify-between rounded-md border-2 border-transparent bg-[#f7f7f7] p-3 text-white hover:border-blue-500 hover:bg-transparent dark:bg-bodyblack">
  <a href={json.url} target="_blank" class="cursor-pointer select-none truncate">
    <h2 class="truncate text-sm font-bold text-gray-d00 dark:text-gray-200 md:text-base">
      {json.recName}
    </h2>
  </a>
  <div class="flex items-center justify-end px-3 text-gray-100">
    <a name="tooltip" id="Analytics" tooltip-position="top" href="#/analytics/documents/single?id={json.id}" target="_blank" style="text-decoration: none;" type="button" class="flex cursor-pointer items-center justify-center rounded-full py-2 px-3 text-sm font-medium text-[#FF6A00] hover:bg-[#FF6A00] hover:text-white active:bg-[#FF6A00] sm:px-5">
      <i class="fa-solid fa-chart-mixed" />
      <span class="hidden lg:block">&nbsp;&nbsp;Analytics&nbsp;</span>
    </a>
    <button
      name="tooltip"
      id="View Info"
      tooltip-position="top"
      style="text-decoration: none;"
      on:click={() => {
        showInfoModal = true
      }}
      type="button"
      class="flex cursor-pointer items-center justify-center rounded-full py-2 px-3 text-sm font-medium text-yellow-500 hover:bg-yellow-500 hover:text-white active:bg-yellow-400 sm:px-5"
    >
      <i class="fa-solid fa-eye" />
      <span class="hidden lg:block">&nbsp;&nbsp;View&nbsp;Info&nbsp;&nbsp;</span>
    </button>
    <a name="tooltip" id="Open URL" tooltip-position="top" href={json.url} target="_blank" class="flex items-center justify-center rounded-full px-3 py-2 text-sm font-medium text-sky-500 hover:bg-sky-500 hover:text-white active:bg-sky-600 active:text-white sm:px-5">
      <i class="fa-solid fa-arrow-up-right-from-square" />
      <span class="hidden lg:block">&nbsp;&nbsp;Open&nbsp;URL&nbsp;&nbsp;</span>
    </a>

    <div class="relative">
      <button name="tooltip" id="Copy URL" tooltip-position="top" on:click={copyURL} type="button" class="flex items-center justify-center rounded-full py-2 px-3 text-sm font-medium text-green-500 hover:bg-green-500 hover:text-white active:bg-green-600 active:text-white sm:px-5">
        <i class="fa-solid fa-copy" />
        <span class="hidden lg:block">&nbsp;&nbsp;Copy&nbsp;URL&nbsp;&nbsp;</span>
      </button>

      <div class="absolute left-[20%] z-10 rounded-md bg-black px-3 py-1 {popover ? 'animate-copy' : 'hidden'}">
        <h1 class="text-sm font-medium text-white">Copied</h1>
      </div>
    </div>
  </div>
</div>

<style>
  ::-webkit-scrollbar-thumb {
    background: #f7f7f7;
    border-radius: 20px;
  }
  ::-webkit-scrollbar {
    height: 4px;
  }
</style>
